export default function getExpirableImageBase64Src(imageSrc: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const tempImg = new Image();
        tempImg.src = imageSrc;
        tempImg.crossOrigin = 'anonymous';
        tempImg.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            //Set canvas size;
            canvas.width = tempImg.width;
            canvas.height = tempImg.height;
            context.drawImage(tempImg, 0, 0);
            resolve(canvas.toDataURL());
        };
        tempImg.onerror = reject;
    });
}
